export function getProductFirstImage(product: any, size: string = 'thumbnail'): string {
  const variants = product?.images?.[0]?.image_data?.variants
  if (variants) {
    for (const url of variants) {
      if (url.includes(`/${size}`)) {
        return url
      }
    }
  }

  return '/product_placeholder.webp'
}
